export default __webpack_public_path__ + "static/media/humboldt.f7c0ca5b.svg";